<template>
  <v-app>
    <v-content>
      <v-snackbar
        v-model="showErrorMessage"
        color="error"
        :timeout="6000"
        :top="true"
        :right="true"
      >
        {{ snackbarErrorMessage }}
        <v-btn text dark @click="showErrorMessage = false">Fechar</v-btn>
      </v-snackbar>

      <v-snackbar
        v-model="showSuccessMessage"
        color="success"
        :timeout="16000"
        vertical="vertical"
        :top="true"
        :right="true"
      >
        {{ snackbarSuccessMessage }}
        <v-btn dark @click="showSuccessMessage = false">Fechar</v-btn>
      </v-snackbar>

      <v-snackbar
        v-model="showWarningMessage"
        color="warning"
        :timeout="16000"
        vertical="vertical"
        :top="true"
        :right="true"
      >
        {{ snackbarWarningMessage }}
        <v-btn dark @click="showWarningMessage = false">Fechar</v-btn>
      </v-snackbar>

      <v-snackbar
        v-model="showInfoMessage"
        color="default"
        :timeout="16000"
        vertical="vertical"
        :top="true"
        :right="true"
      >
        {{ snackbarInfoMessage }}
        <v-btn dark @click="showInfoMessage = false">Fechar</v-btn>
      </v-snackbar>
      <!-- <Loader v-show="showLoader" /> -->
      <router-view />
    </v-content>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import CommonHelper from "@/scripts/helpers/common.helper";
// import Loader from "@/components/Loader";
export default {
  name: "App",
  components: {
    // Loader
  },
  data() {
    return {
      showErrorMessage: false,
      showSuccessMessage: false,
      showWarningMessage: false,
      showInfoMessage: false
    };
  },
  computed: {
    ...mapGetters([
      //"showLoader",
      "snackbarErrorMessage",
      "snackbarSuccessMessage",
      "snackbarWarningMessage",
      "snackbarInfoMessage"
    ])
  },
  watch: {
    showErrorMessage() {
      if (!this.showErrorMessage) {
        CommonHelper.swal("", "", "error");
      }
    },
    snackbarErrorMessage() {
      if (this.snackbarErrorMessage) {
        this.showErrorMessage = true;
      }
    },
    showSuccessMessage() {
      if (!this.showSuccessMessage) {
        CommonHelper.swal("", "", "success");
      }
    },
    snackbarSuccessMessage() {
      if (this.snackbarSuccessMessage) {
        this.showSuccessMessage = true;
      }
    },
    showWarningMessage() {
      if (!this.showWarningMessage) {
        CommonHelper.swal("", "", "warning");
      }
    },
    snackbarWarningMessage() {
      if (this.snackbarWarningMessage) {
        this.showWarningMessage = true;
      }
    },
    showInfoMessage() {
      if (!this.showInfoMessage) {
        CommonHelper.swal("", "", "info");
      }
    },
    snackbarInfoMessage() {
      if (this.snackbarInfoMessage) {
        this.showInfoMessage = true;
      }
    }
  }
};
</script>
